module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA1.a5426b68.jpg";